import { Button, LoadingDarkIcon, LoadingLightIcon } from "@minervaproject/fds";
import React from "react";

const SubmitButton = ({ loading, text, kind, icon, mt = 5, mb = 0 }) => {
  const LoadingIcon = kind === "secondary" ? LoadingDarkIcon : LoadingLightIcon;
  return (
    <Button
      type="submit"
      mt={mt}
      mb={mb}
      fullWidth
      height="42px"
      overflowY="hidden"
      kind={kind}
      icon={icon}
      className="submit"
    >
      <span className="mx-auto">{loading ? <LoadingIcon /> : text}</span>
    </Button>
  );
};

export { SubmitButton };
